import { Typography } from '@material-ui/core';
import React from 'react';
import Masonry from 'react-masonry-css';
import { withRouter } from 'react-router-dom';
import AnotacaoListItem from './AnotacaoListItem';

function AnotacaoList(props) {
    const { anotacoes } = props;

    return (
        (!anotacoes || anotacoes.length === 0) ?
            (
                <div className="flex items-center justify-center h-full py-32">
                    <Typography color="textSecondary" variant="h5">
                        Não há anotações!
                    </Typography>
                </div>
            ) :
            (
                <div className="flex flex-wrap w-full">
                    <Masonry
                        breakpointCols={{
                            default: 6,
                            1920: 5,
                            1600: 4,
                            1366: 3,
                            1280: 4,
                            960: 3,
                            600: 2,
                            480: 1
                        }}
                        className="my-masonry-grid flex w-full"
                        columnClassName="my-masonry-grid_column flex flex-col p-8">
                        {anotacoes.map(anotacao => (
                            <AnotacaoListItem
                                key={anotacao.id}
                                anotacao={anotacao}
                                openDialog={props.openDialog}
                                className="w-full rounded-8 mb-16"
                            />
                        ))}
                    </Masonry>
                </div>
            )
    )
}

export default withRouter(AnotacaoList);
